// src/components/database/SurgeonsList.tsx
import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Skeleton,
	IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import globalAxios from "../../globalAxios";
import { useNavigate } from "react-router-dom";

const SurgeonsList = () => {
	const [surgeons, setSurgeons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const navigate = useNavigate();

	const joinSpecialty = (spec?: string[]) =>
		Array.isArray(spec) && spec.length ? spec.join(", ") : "—";
	console.log("surg ", surgeons);
	// src/components/database/SurgeonsList.tsx
	useEffect(() => {
		const fetchSurgeons = async () => {
			console.debug("[SURGEONS] GET /surgeons …");
			try {
				setLoading(true);
				const res = await globalAxios.get("/surgeons"); // <-- existing route
				const list = res.data?.surgeons ?? [];
				console.debug("[SURGEONS] loaded", { count: list.length });
				setSurgeons(list);
			} catch (err) {
				console.error("Failed to fetch surgeons", err);
				setError(err);
			} finally {
				setLoading(false);
			}
		};
		fetchSurgeons();
	}, []);

	const handleOpenSurgeon = (s) => {
		if (!s?.id) return;
		const name = `${s.first_name || ""} ${s.last_name || ""}`.trim();
		// Pass lightweight state for immediate UI
		navigate(`/surgeons/${s.id}`, { state: { name } });
	};

	return (
		<Box sx={{ mt: 4, maxWidth: 1000 }}>
			<Typography variant="h5" gutterBottom>
				Surgeons
			</Typography>

			{loading ? (
				<SkeletonTable />
			) : error ? (
				<Typography color="error">Failed to load surgeons.</Typography>
			) : (
				<TableContainer component={Paper}>
					<Table size="small">
						<TableHead sx={{ backgroundColor: "grey.100" }}>
							<TableRow>
								<TableCell>Name</TableCell>
								<TableCell>Speciality</TableCell>
								<TableCell></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{surgeons.map((s) => (
								<TableRow key={s.id}>
									<TableCell>
										{(s.first_name || "") +
											" " +
											(s.last_name || "")}
									</TableCell>
									<TableCell>
										{joinSpecialty(s.specialty)}
									</TableCell>
									<TableCell align="right">
										<IconButton
											sx={{ p: 0 }}
											onClick={() => handleOpenSurgeon(s)}
										>
											<ArrowForwardIosIcon fontSize="small" />
										</IconButton>
									</TableCell>
								</TableRow>
							))}
							{surgeons.length === 0 && (
								<TableRow>
									<TableCell colSpan={3}>
										<Typography variant="body2">
											No surgeons found.
										</Typography>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</Box>
	);
};

const SkeletonTable = () => (
	<TableContainer component={Paper}>
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>
						<Skeleton variant="text" width="60%" />
					</TableCell>
					<TableCell>
						<Skeleton variant="text" width="40%" />
					</TableCell>
					<TableCell></TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{Array.from({ length: 5 }).map((_, i) => (
					<TableRow key={i}>
						<TableCell>
							<Skeleton variant="text" width="60%" />
						</TableCell>
						<TableCell>
							<Skeleton variant="text" width="40%" />
						</TableCell>
						<TableCell></TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	</TableContainer>
);

export default SurgeonsList;
